<template>
  <table class="info-table">
    <tr>
      <!-- <td>Ime:</td> -->
      <td>
        <b>{{ data.cow.name }} - {{ data.cow.earringNumber }}</b>
      </td>
    </tr>
    <!-- <tr>
      <td>Broj naušnice:</td>
      <td>
        <b>{{ data.cow.earringNumber }}</b>
      </td>
    </tr> -->
    <tr>
      <td colspan="2" :class="data.daysAgo > 0 ? 'red-text' : ''">
        <b>{{ moment.utc(data.time).local().format("DD.MM.YYYY HH:mm:ss") }}</b>
      </td>
    </tr>
    <tr v-if="!hover">
      <td>
        <img
          class="img-icon"
          src="/24.png"
          @click="onClick24"
          title="Kretanje u poslednja 24 sata"
        />
        <img
          class="img-icon"
          src="/track.png"
          @click="onClickTrack"
          title="Poslednjih 20 pozicija"
        />
      </td>
    </tr>
    <!-- <tr v-if="data.daysAgo > 0">
      <td colspan="2" class="red-text">
        <b>Prije {{ data.daysAgo }} dana</b>
      </td>
    </tr> -->
  </table>
</template>
<script>
import store from "@/store/index";
import moment from "moment";
export default {
  props: ["data", "hover"],
  data() {
    return {
      moment: moment,
    };
  },
  methods: {
    onClick24() {
      this.executeSearch(true, false);
      this.$emit("searchExecuted");
    },
    onClickTrack() {
      this.executeSearch(false, true);
      this.$emit("searchExecuted");
    },
    executeSearch(last24Hours, last20Points) {
      var $this = this;
      store
        .dispatch("cattle/GET_COW_MOVING_HISTORY", {
          cow: this.data.cow,
          last24Hours,
          last20Points,
        })
        .then((response) => {
          if (response.data.cowMovingHistory.length > 0)
            store.commit(
              "cattle/SET_CENTER",
              response.data.cowMovingHistory[
                response.data.cowMovingHistory.length - 1
              ].position
            );
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.info-table {
  margin: 10px 0;
  font-size: 14px;
  td {
    padding-top: 8px;
  }
  td:first-child {
    padding-right: 15px;
  }
  .red-text {
    color: red;
  }
}
.img-icon {
  margin-right: 10px;
  padding: 5px;
  &:hover {
    background-color: gray;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
